import { FETCH_PRODUCT_RES } from '../actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_PRODUCT_RES:
      return action.payload;
    default:
      return state;
  }
}
